import { ProfileNoteType } from 'types';
import { baseQuery } from '../baseQuery';

export const getNoteTypes = async () => {
  const { data } = await baseQuery('note-types');

  return data as ProfileNoteType[];
};
